import { JobType } from 'wisestep-api';

export default function formatJobInsights(jobType: JobType) {
  if (jobType) {
    return String(jobType);
  } else return '';
}
